import PropTypes from 'prop-types';
import { omitBy, isNil } from 'lodash/fp';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import SidebarContainer from '../SidebarContainer';
import rolesActions from '../../redux/roles/actions';
import ContentPage from '../ContentPage';
import ErrorMessage from '../../components/ErrorMessage';

import RoleEditor from '../../components/RoleEditor';

class Role extends Component {
  componentDidMount() {
    const { roleId } = this.props.match.params;
    if (roleId) {
      this.props.actions.roleRequest(roleId);
      this.props.actions.resourcesRequest();
    } else {
      this.props.actions.resetRole(roleId);
    }
    this.props.actions.rolesRequest();
  }

  onUpdate = (role) => {
    this.props.actions.updateRoleRequest(role);
  };

  render() {
    const { roles } = this.props;
    const { error, fetching } = roles;
    // nulls are invalid in JSON schema
    const role = omitBy(isNil)(roles.role);
    return (
      <SidebarContainer title={role.name} logo={role.logo}>
        <div className="form-packs-table">
          {error && <ErrorMessage error={error} />}
          {role.role && (
            <RoleEditor
              role={role}
              roles={roles}
              resources={roles.resources}
              fetching={fetching}
              onUpdate={this.onUpdate}
            />
          )}
        </div>
      </SidebarContainer>
    );
  }
}

Role.propTypes = {
  match: PropTypes.object,
  actions: PropTypes.object,
  roles: PropTypes.object,
};

const mapStateToProps = ({ roles }) => ({
  roles,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      ...rolesActions,
    },
    dispatch,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContentPage(Role));
